import { Navigate, useLocation } from "react-router-dom";
import { useClientAuth } from "@/contexts/ClientAuthContext";

interface ClientProtectedRouteProps {
  children: React.ReactNode;
}

const ClientProtectedRoute = ({ children }: ClientProtectedRouteProps) => {
  const { user, loading, roleLoading, isClient } = useClientAuth();
  const location = useLocation();

  if (loading || roleLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/client-auth" state={{ from: location }} replace />;
  }

  if (!isClient) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};


export default ClientProtectedRoute;
